<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-usd-circle fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{transaction.title}}</div>
            <div class="meta mt-1" v-if="transaction.payment_plans && transaction.payment_plans.users">
                <i class="far fa-user mr-2 fa-fw"></i>{{transaction.payment_plans.users.first_name}} {{transaction.payment_plans.users.last_name}} ({{transaction.payment_plans.users.id}})
            </div>
            <div class="meta" v-if="transaction.payment_plans">
                <i class="far fa-money-check-alt mr-2 fa-fw"></i>R{{transaction.payment_plans.id}}
            </div>
            <div class="meta"><i class="far fa-usd-circle mr-2 fa-fw"></i>{{transaction.total | currency}}</div>
            <div class="meta"><i class="far fa-clock mr-2 fa-fw"></i>{{transaction.created_at | moment('MMMM Do, YYYY h:mm a')}}</div>
            <div class="meta" v-if="transaction.result==='failure'"><i class="far fa-ban mr-2 fa-fw"></i>{{transaction.fail_msg}}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="fas fa-check" v-if="transaction.result==='success'"></i><i class="fas fa-ban" v-if="transaction.result==='failure'"></i></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
                <div class="data mt-1">
                    <data-row mini title="Complete"><i class="far fa-check" v-if="transaction.is_complete"></i></data-row>
                    <data-row mini title="Settling"><i class="far fa-check" v-if="transaction.is_settling"></i></data-row>
                    <data-row mini title="Voidable"><i class="far fa-check" v-if="transaction.is_voidable"></i></data-row>
                    <data-row mini title="Voided"><i class="far fa-check" v-if="transaction.is_voided"></i></data-row>
                    <data-row mini title="Result">{{transaction.result}}</data-row>
                    <data-row mini title="Fail Message">{{transaction.fail_msg}}</data-row>
                    <data-row mini title="Created">{{transaction.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="Settled">{{transaction.settled_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="Completed">{{transaction.completed_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="Last Poll">{{transaction.last_polled_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="ID">{{transaction.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'PlanTransactionTile',
        components: {CardListItem, DataRow},
        props: {
            card: {
                required: true
            },
            transaction: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
